export type FolderImportKind = 'image' | 'pdf' | 'audio' | 'svg' | 'cad' | 'other';

export interface ClassifiedFiles {
  images: File[];
  pdfs: File[];
  audio: File[];
  svgs: File[];
  cad: File[];
  other: File[];
}

const RASTER_EXT = /\.(jpe?g|png|gif|webp|bmp|heic|heif)$/i;

export function classifyFile(file: File): FolderImportKind {
  const name = file.name.toLowerCase();
  const type = (file.type || '').toLowerCase();

  if (/\.(dwg|dxf)$/i.test(name)) return 'cad';
  if (type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (type.startsWith('audio/') || /\.(mp3|wav|m4a|aac|ogg|flac|webm)$/i.test(name)) return 'audio';
  if (type === 'image/svg+xml' || name.endsWith('.svg')) return 'svg';
  if (type.startsWith('image/') || RASTER_EXT.test(name)) return 'image';
  return 'other';
}

export function classifyFiles(files: File[]): ClassifiedFiles {
  const out: ClassifiedFiles = {
    images: [],
    pdfs: [],
    audio: [],
    svgs: [],
    cad: [],
    other: [],
  };
  for (const f of files) {
    const k = classifyFile(f);
    if (k === 'image') out.images.push(f);
    else if (k === 'pdf') out.pdfs.push(f);
    else if (k === 'audio') out.audio.push(f);
    else if (k === 'svg') out.svgs.push(f);
    else if (k === 'cad') out.cad.push(f);
    else out.other.push(f);
  }
  return out;
}

